import { jsx as u } from "react/jsx-runtime";
import { Tooltip as o } from "@strata/react-tooltip";
import v from "classnames";
import "./main.scss";
const R = {
  DEFAULT: "default",
  IN_PROGRESS: "in-progress",
  WARNING: "warning",
  CAUTION: "caution",
  SUCCESS: "success",
  TIP: "tip"
}, F = {
  [R.DEFAULT]: o.Intent.DEFAULT,
  [R.IN_PROGRESS]: o.Intent.INFO,
  [R.WARNING]: o.Intent.WARNING,
  [R.CAUTION]: o.Intent.ERROR,
  [R.SUCCESS]: o.Intent.SUCCESS,
  [R.TIP]: o.Intent.INFO
}, e = ({
  status: t,
  message: i,
  className: S = void 0,
  tooltipText: r = void 0,
  popoverTargetClassName: T = void 0
}) => {
  const P = /* @__PURE__ */ u("div", { className: v("sds_indicator", `sds_indicator--${t}`, S), children: i });
  return r ? /* @__PURE__ */ u(
    o,
    {
      intent: F[t],
      content: r,
      className: T,
      children: P
    }
  ) : P;
};
e.Status = R;
const c = {
  APPEALED: "APPEALED",
  APPROVED: "APPROVED",
  DENIED: "DENIED",
  NOAUTHREQ: "NOAUTHREQ",
  PENDING: "PENDING"
};
function b(t) {
  switch (t) {
    case c.DENIED:
      return e.Status.CAUTION;
    case c.APPEALED:
      return e.Status.WARNING;
    case c.APPROVED:
      return e.Status.SUCCESS;
    case c.NOAUTHREQ:
      return e.Status.IN_PROGRESS;
    default:
      return e.Status.DEFAULT;
  }
}
const d = {
  [c.APPROVED]: "Approved",
  [c.APPEALED]: "Appealed",
  [c.DENIED]: "Denied",
  [c.NOAUTHREQ]: "No Auth Req.",
  [c.PENDING]: "Pending"
}, C = ({
  status: t = void 0
}) => /* @__PURE__ */ u(
  e,
  {
    status: b(t),
    message: t && d[t],
    className: "sds_indicator--auth-request-status"
  }
);
C.Statuses = c;
C.StatusMessages = d;
const a = {
  // Shared statuses
  /** Claim was rejected because it needed prior auth */
  REJECTED: "REJECTED",
  // finance only statuses
  /** Claim was submitted and paid successfully */
  CLOSED: "CLOSED",
  /** Claim has been reversed */
  REVERSED: "REVERSED",
  /** Claim was submitted by the wrong supplier */
  INCORRECT: "INCORRECT",
  /** Claim was submitted by the correct supplier with the wrong amount */
  OPEN: "OPEN",
  /** Claim is older than 180 days */
  AGED: "AGED",
  /** Claim is outside the referral period, so it is not associated with a referral */
  OUTSIDE: "OUTSIDE",
  // medbilling only statuses
  /** Claim was submitted and paid successfully */
  PAID: "PAID",
  ERROR: "ERROR",
  PROCESSING: "PROCESSING",
  SUBMITTED: "SUBMITTED"
};
function y(t) {
  switch (t) {
    case a.PAID:
    case a.CLOSED:
      return e.Status.SUCCESS;
    case a.INCORRECT:
    case a.OPEN:
    case a.REJECTED:
    case a.ERROR:
      return e.Status.CAUTION;
    default:
      return e.Status.DEFAULT;
  }
}
const l = {
  [a.REJECTED]: "Rejected",
  [a.CLOSED]: "Paid",
  [a.REVERSED]: "Reversed",
  [a.INCORRECT]: "Incorrect",
  [a.OPEN]: "Discrepancy",
  [a.AGED]: "Aged",
  [a.OUTSIDE]: "Filled",
  [a.PAID]: "Paid",
  [a.ERROR]: "Error",
  [a.PROCESSING]: "Processing",
  [a.SUBMITTED]: "Submitted"
}, w = {
  [a.REJECTED]: "Claim has been rejected",
  [a.CLOSED]: "Claim has paid successfully",
  [a.REVERSED]: "Claim was reversed",
  [a.INCORRECT]: "Claim was paid, but was submitted by the wrong pharmacy",
  [a.OPEN]: "Claim was paid and submitted by the correct pharmacy, but for the wrong amount",
  [a.AGED]: "Claim is older than 180 days",
  [a.OUTSIDE]: "Claim is outside of the referral period.",
  [a.PAID]: "Claim has paid successfully",
  [a.ERROR]: "Error processing claim",
  [a.PROCESSING]: "Claim is being processed",
  [a.SUBMITTED]: "Claim has been submitted to payer successfully"
}, O = ({
  status: t = void 0,
  overrideTooltipText: i = void 0,
  overrideStatusMessages: S = void 0
}) => {
  const r = {
    ...l,
    ...S
  }, T = t && w[t];
  return /* @__PURE__ */ u(
    e,
    {
      status: y(t),
      message: t && r[t],
      className: "sds_indicator--claim-status",
      tooltipText: i ?? T
    }
  );
};
O.Statuses = a;
O.StatusMessages = l;
const E = {
  DRAFT: "DRAFT",
  EXTAPPROVE: "EXTAPPROVE",
  EXTCHANGE: "EXTCHANGE",
  EXTREVIEW: "EXTREVIEW",
  INTAPPROVE: "INTAPPROVE",
  INTCHANGE: "INTCHANGE",
  INTREVIEW: "INTREVIEW",
  IN_PROD: "IN_PROD",
  PEND_PROD: "PEND_PROD",
  RETIRED: "RETIRED",
  SAVED: "SAVED"
};
function $(t) {
  switch (t) {
    case E.EXTREVIEW:
    case E.INTREVIEW:
      return e.Status.WARNING;
    case E.EXTCHANGE:
    case E.INTCHANGE:
      return e.Status.TIP;
    case E.EXTAPPROVE:
    case E.INTAPPROVE:
      return e.Status.SUCCESS;
    case E.IN_PROD:
      return e.Status.IN_PROGRESS;
    default:
      return e.Status.DEFAULT;
  }
}
const U = {
  [E.DRAFT]: "Draft",
  [E.EXTAPPROVE]: "Externally Approved",
  [E.EXTCHANGE]: "External Change Request",
  [E.EXTREVIEW]: "Pend. External Review",
  [E.INTAPPROVE]: "Internally Approved",
  [E.INTCHANGE]: "Internal Change Request",
  [E.INTREVIEW]: "Pend. Internal Review",
  [E.IN_PROD]: "In Production",
  [E.PEND_PROD]: "Pend. Production",
  [E.RETIRED]: "Retired",
  [E.SAVED]: "Draft"
}, L = ({
  status: t = void 0,
  tooltipText: i,
  overrideStatusMessages: S = void 0
}) => {
  const r = {
    ...U,
    ...S
  };
  return /* @__PURE__ */ u(
    e,
    {
      status: $(t),
      message: t && r[t],
      className: "sds_indicator--clinical-policy-status",
      tooltipText: i
    }
  );
};
L.Statuses = E;
L.StatusMessages = U;
const N = {
  CANCELED: "CANCELED",
  COMPLETE: "COMPLETE",
  INCOMPLETE: "INCOMPLETE",
  READY: "READY",
  SUBMITTED: "SUBMITTED"
};
function W(t) {
  switch (t) {
    case N.CANCELED:
      return e.Status.CAUTION;
    case N.INCOMPLETE:
      return e.Status.WARNING;
    case N.COMPLETE:
      return e.Status.SUCCESS;
    default:
      return e.Status.DEFAULT;
  }
}
const g = {
  [N.CANCELED]: "Canceled",
  [N.COMPLETE]: "Complete",
  [N.INCOMPLETE]: "Incomplete",
  [N.READY]: "Ready To Submit",
  [N.SUBMITTED]: "Submitted"
}, f = ({ status: t = void 0 }) => /* @__PURE__ */ u(
  e,
  {
    status: W(t),
    message: t && g[t],
    className: "sds_indicator--intake-status"
  }
);
f.Statuses = N;
f.StatusMessages = g;
const n = {
  APPROV_DEN: "APPROV_DEN",
  APPROV_REQ: "APPROV_REQ",
  APPROVED: "APPROVED",
  CANCELED: "CANCELED",
  COMPLETED: "COMPLETED",
  IN_PROG: "IN_PROG",
  RESOLVED: "RESOLVED",
  UNASSIGNED: "UNASSIGNED"
};
function X(t) {
  switch (t) {
    case n.APPROV_DEN:
    case n.CANCELED:
      return e.Status.CAUTION;
    case n.APPROV_REQ:
      return e.Status.WARNING;
    case n.APPROVED:
    case n.RESOLVED:
      return e.Status.SUCCESS;
    case n.IN_PROG:
      return e.Status.IN_PROGRESS;
    default:
      return e.Status.DEFAULT;
  }
}
const p = {
  [n.APPROV_DEN]: "Approval Den.",
  [n.APPROV_REQ]: "Approval Req.",
  [n.APPROVED]: "Approved",
  [n.CANCELED]: "Canceled",
  [n.COMPLETED]: "Closed",
  [n.IN_PROG]: "In Progress",
  [n.RESOLVED]: "Resolved",
  [n.UNASSIGNED]: "Unassigned"
}, m = ({
  status: t = void 0
}) => /* @__PURE__ */ u(
  e,
  {
    status: X(t),
    message: t && p[t],
    className: "sds_indicator--payer-request-status"
  }
);
m.Statuses = n;
m.StatusMessages = p;
const D = {
  NOT_STARTED: "not-started",
  IN_PROGRESS: "in-progress",
  PENDING: "pending",
  SUCCESSFUL: "successful",
  UNSUCCESSFUL: "unsuccessful",
  VOIDED: "voided"
};
function x(t) {
  switch (t) {
    case D.UNSUCCESSFUL:
      return e.Status.CAUTION;
    case D.SUCCESSFUL:
      return e.Status.SUCCESS;
    case D.IN_PROGRESS:
      return e.Status.IN_PROGRESS;
    default:
      return e.Status.DEFAULT;
  }
}
const h = {
  [D.NOT_STARTED]: "Not Started",
  [D.IN_PROGRESS]: "In Progress",
  [D.PENDING]: "Pending",
  [D.SUCCESSFUL]: "Successful",
  [D.UNSUCCESSFUL]: "Unsuccessful",
  [D.VOIDED]: "Voided"
}, M = ({
  status: t = void 0,
  tooltipText: i,
  overrideStatusMessages: S = void 0
}) => {
  const r = {
    ...h,
    ...S
  };
  return /* @__PURE__ */ u(
    e,
    {
      status: x(t),
      message: t && r[t],
      className: "sds_indicator--performance-status",
      tooltipText: i
    }
  );
};
M.Statuses = D;
M.StatusMessages = h;
const s = {
  BEN_DENIAL: "BEN_DENIAL",
  CANCELLED: "CANCELLED",
  DENIED: "DENIED",
  DISCONTD: "DISCONTD",
  EXPIRED: "EXPIRED",
  FMH: "FMH",
  MARKET: "MARKET",
  OUTREACH: "OUTREACH",
  PENDAUTH: "PENDAUTH",
  PENDINTAKE: "PENDINTAKE",
  PENDOUT: "PENDOUT",
  PENDREAUTH: "PENDREAUTH",
  PENDSTART: "PENDSTART",
  PHARM: "PHARM",
  REAUTHED: "REAUTHED",
  RESEARCH: "RESEARCH",
  UNMANAGED: "UNMANAGED",
  UNAUTHED: "UNAUTHED"
};
function B(t) {
  switch (t) {
    case s.EXPIRED:
      return e.Status.CAUTION;
    case s.PENDINTAKE:
    case s.PENDREAUTH:
      return e.Status.WARNING;
    default:
      return e.Status.DEFAULT;
  }
}
const G = {
  [s.BEN_DENIAL]: "Benefit Denial",
  [s.CANCELLED]: "Cancelled",
  [s.DENIED]: "Denied",
  [s.DISCONTD]: "Discontinued",
  [s.EXPIRED]: "Expired",
  [s.FMH]: "At FMH",
  [s.MARKET]: "Live Referral",
  [s.OUTREACH]: "Ready For Outreach",
  [s.PENDAUTH]: "Processing",
  [s.PENDINTAKE]: "Pend. Intake",
  [s.PENDOUT]: "Pend. Outreach",
  [s.PENDREAUTH]: "Pend. Reauth",
  [s.PENDSTART]: "Pend. Auth Start",
  [s.PHARM]: "Active",
  [s.REAUTHED]: "Reauthorized",
  [s.RESEARCH]: "Research Required",
  [s.UNMANAGED]: "Unmanaged",
  [s.UNAUTHED]: "Auth Expired"
}, q = {
  [s.BEN_DENIAL]: "Patient does not have the applicable benefit for medication.",
  [s.CANCELLED]: "FMH is no longer managing this referral.",
  [s.DENIED]: "Authorization denied due to not meeting health plan's clinical policy.",
  [s.DISCONTD]: "Therapy has been discontinued.",
  [s.EXPIRED]: "Referral is no longer active. Please contact the prescriber for reauthorization if needed.",
  [s.FMH]: "Servicing pharmacy will be identified soon. Free Market Health can be contacted at (833) 554-2669.",
  [s.MARKET]: "Currently a Live Referral.",
  [s.OUTREACH]: "Patient outreach can begin now.",
  [s.PENDAUTH]: "This referral is processing. Details are unavailable until completed.",
  [s.PENDINTAKE]: "Pending pharmacy's acceptance of this referral.",
  [s.PENDOUT]: "Patient outreach can begin on the outreach start date.",
  [s.PENDREAUTH]: "The auth for this referral expires within 30 days. Please contact the prescriber for reauthorization if needed.",
  [s.PENDSTART]: "Referral is pending authorization start date.",
  [s.PHARM]: "Currently being serviced.",
  [s.REAUTHED]: 'Referral is close to expiration. Reauth is completed, and a new referral with status "PENDING RENEWAL" has been created and is waiting to be accepted/declined by the pharmacy.',
  [s.RESEARCH]: "Referral requires research to determine if it can be updated to a Live Referral.",
  [s.UNMANAGED]: "Referral is to be managed by the prescribing office. (Business as usual).",
  [s.UNAUTHED]: void 0
}, V = ({
  status: t = void 0,
  overrideTooltipText: i = void 0,
  overrideStatusMessages: S = void 0
}) => {
  const r = {
    ...G,
    ...S
  }, T = t && q[t];
  return /* @__PURE__ */ u(
    e,
    {
      status: B(t),
      message: t && r[t],
      className: "sds_indicator--referral-status",
      tooltipText: i ?? T
    }
  );
};
V.Statuses = s;
V.StatusMessages = G;
const I = {
  ACTIVE: "ACTIVE",
  DISCONTINUED: "DISCONTINUED",
  UNMANAGED: "UNMANAGED"
}, K = {
  [I.ACTIVE]: e.Status.SUCCESS,
  [I.UNMANAGED]: e.Status.DEFAULT,
  [I.DISCONTINUED]: e.Status.CAUTION
}, Q = ({ status: t }) => /* @__PURE__ */ u(
  e,
  {
    message: t,
    status: K[t],
    className: "sds_indicator--treatment-status"
  }
);
Q.Statuses = I;
const A = {
  COMPLETED: "COMPLETED",
  FAILED: "FAILED",
  TODO: "TODO",
  WAITING: "WAITING"
};
function k(t) {
  switch (t) {
    case A.FAILED:
      return e.Status.CAUTION;
    case A.COMPLETED:
      return e.Status.SUCCESS;
    default:
      return e.Status.DEFAULT;
  }
}
const H = {
  [A.COMPLETED]: "Completed",
  [A.FAILED]: "Expired",
  [A.TODO]: "To Do",
  [A.WAITING]: "Pending"
}, _ = ({
  status: t = void 0,
  tooltipText: i,
  overrideStatusMessages: S = void 0
}) => {
  const r = {
    ...H,
    ...S
  };
  return /* @__PURE__ */ u(
    e,
    {
      status: k(t),
      message: t && r[t],
      className: "sds_indicator--worklist-status",
      tooltipText: i
    }
  );
};
_.Statuses = A;
_.StatusMessages = H;
export {
  C as AuthRequestStatusIndicator,
  O as ClaimStatusIndicator,
  L as ClinicalPolicyStatusIndicator,
  f as IntakeStatusIndicator,
  m as PayerRequestStatusIndicator,
  M as PerformanceStatusIndicator,
  V as ReferralStatusIndicator,
  e as StatusIndicator,
  Q as TreatmentStatusIndicator,
  _ as WorklistStatusIndicator
};
//# sourceMappingURL=index.js.map
